import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=2025547a&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=2025547a&lang=scss&scoped=true&"
import style1 from "./orders.vue?vue&type=style&index=1&id=2025547a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025547a",
  null
  
)

component.options.__file = "orders.vue"
export default component.exports